// Google Places API functions
const GOOGLE_MAPS_API_KEY = "AIzaSyBw1Lb3hcPizXG96gR5ivqhlpMTOjM5SjU";


// Extract normalized geographic bounds using input coordinates (place coordinates) 
function normalizeMapBounds(boundsInput) {
  const coordinates = Array.isArray(boundsInput)
    ? boundsInput.map((value) => Number(value))
    : String(boundsInput || "")
      .split(",")
      .map((value) => Number.parseFloat(value));

  if (coordinates.length !== 4 || coordinates.some((value) => !Number.isFinite(value))) {
    return null;
  }

  const [lat1, lng1, lat2, lng2] = coordinates;
  const crossesAntimeridian = Math.abs(lng2 - lng1) > 180;

  return {
    south: Math.min(lat1, lat2),
    west: crossesAntimeridian ? Math.max(lng1, lng2) : Math.min(lng1, lng2),
    north: Math.max(lat1, lat2),
    east: crossesAntimeridian ? Math.min(lng1, lng2) : Math.max(lng1, lng2)
  };
}

function viewportToMapBounds(viewport) {
  return normalizeMapBounds([
    viewport?.low?.latitude,
    viewport?.low?.longitude,
    viewport?.high?.latitude,
    viewport?.high?.longitude
  ]);
}

function mapBoundsToSerializedBBox(bounds) {
  if (!bounds) {
    return null;
  }

  return [bounds.south, bounds.west, bounds.north, bounds.east];
}

function mapBoundsToAlgoliaBoundingBox(bounds) {
  if (!bounds) {
    return null;
  }

  // geoSearch works with a north-east/south-west pair in its refinement state.
  return [bounds.north, bounds.east, bounds.south, bounds.west];
}


// Normalize aroundLatLng url param ("34.0522,-118.2437" -> { lat: 34.0522, lng: -118.2437 })
function parseAroundLatLng(rawValue) {
  if (!rawValue) {
    return null;
  }

  const [lat, lng] = String(rawValue)
    .split(",")
    .map((value) => Number.parseFloat(value.trim()));

  if (![lat, lng].every((value) => Number.isFinite(value))) {
    return null;
  }

  return { lat, lng };
}

function viewportToInsideBoundingBox(viewport) {
  return mapBoundsToSerializedBBox(viewportToMapBounds(viewport));
}

async function getGooglePlacesSuggestions(query) {
  const response = await fetch("https://places.googleapis.com/v1/places:autocomplete", {
    method: "POST",
    headers: {
      "X-Goog-Api-Key": GOOGLE_MAPS_API_KEY,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      input: query,
      includeQueryPredictions: true,
      "includedPrimaryTypes": ["country", "locality", 'sublocality', "administrative_area_level_1", "colloquial_area"],
      "languageCode": "en"
    })
  });
  const data = await response.json();
  return data?.suggestions || [];
}

async function getPlaceDetails(placeId) {
  const response = await fetch(`https://places.googleapis.com/v1/places/${placeId}?languageCode=en`, {
    method: "GET",
    headers: {
      "X-Goog-Api-Key": GOOGLE_MAPS_API_KEY,
      "Content-Type": "application/json",
      "X-Goog-FieldMask": "*"
    }
  });
  return await response.json();
}

function processPlaceDataAndRedirect(placeData, fallbackQuery) {
  if (!placeData) {
    return;
  }

  const searchParams = new URLSearchParams();

  if (placeData.viewport) {
    const bbox = viewportToInsideBoundingBox(placeData.viewport);
    if (bbox?.length) {
      searchParams.set('bbox', bbox.join(','));
    }
  }

  if (placeData.addressComponents?.length) {
    const country = placeData.addressComponents.find((a) => a.types?.includes("country"))
    if (country) {
      searchParams.set('country', country.longText)
    }
  }

  if (placeData.formattedAddress) {
    //  searchParams.set('query', placeData.formattedAddress)
    // console.log('placeData.formattedAddress', placeData.formattedAddress)

    if (placeData.formattedAddress == 'Melbourne' || placeData.formattedAddress.includes('Melbourne VIC')) {
      searchParams.set('aroundLatLng', placeData.location.latitude + ',' + placeData.location.longitude)
      searchParams.set('aroundRadius', '150000')
      searchParams.delete('bbox')
    }
  }


}

function findMatchingSuggestion(suggestions, query) {
  const queryLower = query.toLowerCase().trim();
  const queryWords = queryLower.split(/[,\s]+/).filter(word => word.length > 0);

  return suggestions.find(suggestion => {
    const suggestionText = suggestion.placePrediction?.text?.text?.toLowerCase() || '';
    const suggestionWords = suggestionText.split(/[,\s]+/).filter(word => word.length > 0);

    return queryWords.every(queryWord =>
      suggestionWords.some(suggestionWord =>
        suggestionWord === queryWord
      )
    );
  });
}


class CustomAlgoliaFactet extends HTMLElement {

  static get observedAttributes() {
    return ['facet-status', 'facet-total-count'];
  }

  constructor() {
    super();
    this.BASE_CDN_URL = "https://cdn.shopify.com/s/files/1/0729/5909/9129/files";
    this.BY_THE_GLASS_LOGO = `${this.BASE_CDN_URL}/coravin-by-the-glass-rating.png?v=1749057912`;
    this.BY_THE_GLASS_1 = `/btg-logo-glass1.svg?v=1753803522`;
    this.BY_THE_GLASS_2 = `/btg-logo-glass2.svg?v=1753803522`;
    this.BY_THE_GLASS_3 = `/btg-logo-glass3.svg?v=1753803522`;
    this.BY_THE_GLASS_4 = `/btg-logo-glass4.png`;


  }


  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === null) return;
    if (name === "facet-status") {
      this.classList.toggle("active", newValue === "active")
    }
    if (name === "facet-total-count") {
      this._handleTotalCountChange(oldValue, newValue)
    }
  }

  _handleTotalCountChange(oldValue, newValue) {
    const intValue = parseInt(newValue);
    const isDisabled = intValue === 0
    this.classList.toggle("disabled", isDisabled);
    const algoliaFacetElement = this.closest("li.ais-RefinementList-item");
    if (algoliaFacetElement) {
      algoliaFacetElement.classList.toggle("disabled", isDisabled);
      algoliaFacetElement.style.pointerEvents = isDisabled ? "none" : "auto";
    }
  }

  connectedCallback() {
    this.render()
    this.querySelector(".custom-facet-filter")?.addEventListener("click", () => {
      const name = this.getAttribute('facet-name');
      const value = this.getAttribute('facet-value');
      this.dispatchEvent(new CustomEvent('facet-value-changed', {
        bubbles: true,
        composed: true,
        detail: { name, value }
      }));
    });

  }

  render() {
    const facetName = this.getAttribute('facet-name');
    const facetValue = this.getAttribute('facet-value');
    const facetStatus = this.getAttribute('facet-status');
    const label = this.getAttribute('facet-label');
    const count = this.getAttribute('facet-total-count');
    const url = this.getAttribute('data-url');
    const isRefined = facetStatus === 'active';


    const ratingValue = parseInt(facetValue);
    const isRatingFacet = facetName === 'meta.custom.rating';
    const facetId = `${facetName}--${facetValue}`;

    this.innerHTML = `
      <div class="custom-facet-filter" data-custom-facet-id="${facetId}">
        <div class="custom-filter-container">
          ${isRatingFacet ? this.renderRatingFacetType(ratingValue, count, facetId) :
        `<a class="facet-link" href="${url || '#'}" style="${isRefined ? 'font-weight: bold' : ''}">
              <div style="display:flex; gap:5px;">
                <span>${label}</span>
                <span data-cf-id-count="${facetId}-count">(${count})</span>
              </div>
            </a>`
      }
          <div class="custom-facet-filter-check"></div>
        </div>
      </div>
    `;


  }


  renderRatingFacetType(value, hitCount, facetId) {

    // Parse images
    let btgImages = [];
    try {
      const btgImagesAttr = this.getAttribute('btg-images');
      if (btgImagesAttr) {
        btgImages = JSON.parse(btgImagesAttr);
      }
    } catch (e) {
      console.warn('Failed to parse btg-images:', e);
    }
    const [image1, image2, image3, image4] = btgImages;

    // Parse texts
    let ratingTexts = {};
    try {
      const ratingTextsAttr = this.getAttribute('btg-rating-texts');
      if (ratingTextsAttr) {
        ratingTexts = JSON.parse(ratingTextsAttr);
      }
    } catch (e) {
      console.warn('Failed to parse btg-rating-texts:', e);
    }

    const ratingData = ratingTexts[value] || {
      title: "Unknown rating",
      subtitle: "Unknown choice"
    };

    const VALUE_NAMES = {
      1: {
        src: image1 || this.BY_THE_GLASS_1

      },
      2: {
        src: image2 || this.BY_THE_GLASS_2
      },
      3: {
        src: image3 || this.BY_THE_GLASS_3
      },
      4: {
        src: image4 || this.BY_THE_GLASS_4
      }
    }
    return `
      <div class="algolia-rating-facet">
          <div class="algolia-rating-facet-container">
            <div class="rating-facet-texts">
              <div style="display: flex; gap: 5px;">
                <span class="rating-facet-title">${ratingData.title}</span>
                <span class="rating-facet-title-count" data-cf-id-count="${facetId}-count">(${hitCount})</span>
              </div>
              <span class="rating-facet-subtitle">${ratingData.subtitle}</span>
            </div>
            <img 
              class="algolia-rating-facet--img"
              src="${this.BASE_CDN_URL}/${this._getFileNameFromShopifyPath(VALUE_NAMES[value]?.src)}"
              loading="lazy"
              alt="Rating image ${ratingData.title}"
            />
          </div>
      </div>
    `;
  }

  _getFileNameFromShopifyPath(path) {
    return path?.replace("files/", "")
  }

}

customElements.define('custom-algolia-facet', CustomAlgoliaFactet);

class CustomFacetModal extends HTMLElement {
  connectedCallback() {
    const facetName = this.getAttribute('facet-name');
    const facetTitle = this.getAttribute('facet-title');
    const clearSingleFilterText = this.getAttribute("clear-filter-text")
    const viewResultsText = this.getAttribute("view-results-text")
    const isToggleRefinement = this.getAttribute("is-toggle-refinement")
 
    const isRefinedAttr = this.getAttribute("is-refined");
    const isRefined = isRefinedAttr === "true" || isRefinedAttr === true;

    // console.log("Other factet======", facetName, isEventFacet)
    this.innerHTML = isToggleRefinement ? `<div id="toggle-facet-${facetName}" data-status class="custom-facet-toggleRefinement">
        <span class="custom-facet-label">${facetTitle}</span>
       <div class="custom-facet-values-container" id="${facetName}--facets-container" tabindex="0"></div>
    </div>` :`
      <input type="checkbox" id="toggle-facet-modal-${facetName}" class="modal-toggle" hidden/>
      <div class="custom-facet-label-container">
        <label data-label-id="custom-facet-label-${facetName}" for="toggle-facet-modal-${facetName}" data-facet-title="${facetTitle}" class="custom-facet-label">${facetTitle}</label>
        <svg id="arrow-down" xmlns="http://www.w3.org/2000/svg" width="11.386" height="5.997" viewBox="0 0 11.386 5.997">
          <path id="Trazado_13" data-name="Trazado 13" d="M37.316,63.232l-4.9,4.779-4.9-4.779a.469.469,0,0,0-.655,0,.446.446,0,0,0,0,.638l5.216,5.085a.491.491,0,0,0,.685,0l5.216-5.085a.446.446,0,0,0,0-.64.469.469,0,0,0-.655,0Z" transform="translate(-26.721 -63.098)"/>
        </svg>
      </div>
      <div class="custom-facet-modal">
        <div class="custom-facet-modal-content">
          <div class="custom-facet-modal-body" tabindex="0">
            <div class="custom-facet-modal-body-header">
              <label for="toggle-facet-modal-${facetName}" class="modal-close-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="18.707" height="18.707" viewBox="0 0 18.707 18.707">
                  <g id="Grupo_312" data-name="Grupo 312" transform="translate(0.354 0.354)">
                    <path id="Trazado_17" data-name="Trazado 17" d="M2800,143l18,18" transform="translate(-2800 -143)" fill="none" stroke="#000" stroke-width="1"/>
                    <path id="Trazado_18" data-name="Trazado 18" d="M2818,143l-18,18" transform="translate(-2800 -143)" fill="none" stroke="#000" stroke-width="1"/>
                  </g>
                </svg>
              </label>
              <span class="custom-facet-header">${facetTitle}</span>
            </div>
            <div class="custom-facet-values-container" id="${facetName}--facets-container" tabindex="0"></div>
          </div>
          <div class="custom-facet-modal-actions">
            <button class="custom-facet-modal-actions-reset" data-facet-name="${facetName}">${clearSingleFilterText}</button>
            <label for="toggle-facet-modal-${facetName}" data-id="view-results-label-${facetName}" data-placeholder-text="${viewResultsText}" class="custom-facet-modal-actions-view"></label>
          </div>
        </div>
      </div> 
    `;
  if(isToggleRefinement){
        const facetElement = document.getElementById(
          `toggle-facet-${facetName}`
        );
        const toggleContainer = document.getElementById(
          `toggle-refinement-event-${facetName}`
        );
        const checkbox = toggleContainer?.querySelector(`input[type="checkbox"]`);
        const updateToggleUI = (checked) => {
          if (!toggleContainer) return;

          toggleContainer.dataset.status =
            checked ? "active" : "inactive";

          toggleContainer.classList.toggle("active", checked);
        };

        // Sync initial state
        if (isRefined && checkbox && !checkbox.checked) {
          checkbox.click();
        }

        updateToggleUI(checkbox?.checked);

        facetElement?.addEventListener("click", () => {
          if (!checkbox) return;

          updateToggleUI(!checkbox.checked);
        });
   }

    this.querySelector('.custom-facet-modal-actions-reset')
      ?.addEventListener('click', () => this.resetRefinement(facetName));

    const facetValuesContainer = this.querySelector('.custom-facet-values-container');
    facetValuesContainer?.addEventListener('scroll', () => {
      const nearBottom =
        facetValuesContainer.scrollTop + facetValuesContainer.clientHeight >=
        facetValuesContainer.scrollHeight - 2;
      facetValuesContainer.classList.toggle('at-bottom', nearBottom);
    });

    const customFacetContainer = this.closest('.custom-facet');
    if (customFacetContainer) {
      customFacetContainer.addEventListener('click', (e) => {

        const checkbox = document.getElementById(`toggle-facet-modal-${facetName}`);

        if (checkbox) {
          const facetValuesContainer = document.getElementById(`${facetName}--facets-container`);
          if (facetValuesContainer) {
            this.updateOverflowState(facetValuesContainer);
          }

          checkbox.checked = !checkbox.checked;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    document.getElementById(`toggle-facet-modal-${facetName}`)?.addEventListener("change", (e) => {
      const targetId = e.target.id;
      document.querySelectorAll('.modal-toggle').forEach(toggle => {
        if (toggle.id !== targetId) {
          toggle.checked = false;
        }
      });
    })
  }

  resetRefinement(facetName) {
    document.dispatchEvent(new CustomEvent('facet-reset', { detail: { facetName }, bubbles: true }));
  }

  updateOverflowState(container) {
    const content = container.firstElementChild;
    if (!content) return false;

    const containerHeight = container.clientHeight;
    const contentHeight = content.getBoundingClientRect().height;

    const overflow = contentHeight > containerHeight + 1;
    container.classList.toggle('has-overflow', overflow);
  }

}

customElements.define('custom-facet-modal', CustomFacetModal);


class AlgoliaSearchWidget extends HTMLElement {
  static get observedAttributes() {
    return ['searchbox-placeholder'];
  }

  constructor() {
    super()
    // Images settings
    this.BTG_IMAGES = this.getAttribute("btg-images") || "[]"
    this.BTG_LOGO = this.getAttribute("btg-rating-logo") || ""
    this.MAP_VIEW_ICON = this.getAttribute("map-view-icon-button") || "";
    this.LIST_VIEW_ICON = this.getAttribute("list-view-icon-button") || "";
    this.CORAVIN_LOGO_IMAGE = this.getAttribute("coravin-logo-image") || "";

    // Texts Settings
    this.CLEAR_FILTERS_TEXT = this.getAttribute("clear-filters-button-text") || "All"
    this.CLEAR_SINGLE_FILTER_TEXT = this.getAttribute("clear-single-filter-button-text") || "Reset"
    this.VIEW_RESULTS_TEXT = this.getAttribute("view-results-button-text") || "View Results"
    this.BTG_RATING_TEXTS = this._getBtgRatingTexts()
    this.WIDGET_STATS_TEXT = this.getAttribute("widget-stats-text") || "Showing: ${VENUES_NUMBER} in ${WIDGET_QUERY}";
    this.WIDGET_STATS_TEXT_NO_QUERY = this.getAttribute("widget-stats-text-no-query") || "Showing: ${VENUES_NUMBER} venues";
    this.WIDGET_VIEW_RESULTS_TEXT = this.getAttribute("widget-view-results-text") || "Show ${VENUES_NUMBER} venues";
    this.WIDGET_VIEW_RESULTS_TEXT_NO_QUERY = this.getAttribute("widget-view-results-text-no-query") || "Show ${VENUES_NUMBER} venues";
    this.HITS_PER_PAGE = Math.max(parseInt(this.getAttribute("hits-per-page"), 10) || 12, 1);
    this.MAP_HITS_PER_PAGE = 1000;
    this.MAP_PIN_BATCH_SIZE = 75;
    this.MAP_CLUSTER_THRESHOLD = 50;
    this.MAP_CLUSTER_BASE_CELL_SIZE = 54;
    this.MAP_PIN_ATTRIBUTES = [
      "id",
      "objectID",
      "handle",
      "title",
      "image",
      "_geoloc",
      "meta.custom.rating",
      "meta.custom.venue_type",
      "meta.custom.region_city",
      "meta.custom.wine_venue_ambiance",
      "meta.custom.event_venue"
    ];
    this.MAP_PIN_CONFIG = {
      size: Math.max(parseInt(this.getAttribute("map-pin-size"), 10) || 23, 1),
      iconSize: Math.max(parseInt(this.getAttribute("map-pin-icon-size"), 10) || 13, 1),
      activeScale: Math.max(parseFloat(this.getAttribute("map-pin-active-scale")) || 1.15, 1)
    };

    // Document settings
    this.WIDGET_HTML_DOCUMENT_TITLE = this.getAttribute("html-title-text") || "Searching"
    this.CURRENT_ROOT_URL = this.getAttribute("root-url") || "/"
    this.TOGGLE_REFINEMENT_URL_PARAM = (this.getAttribute("toggle-refinement-url-param") || "curiosity").trim() || "curiosity";

    this.facets = {};
    this.facetsCounts = {};
    this.activeHits = 0;
    this.initialRender = {};
    this.totalHits = 0;
    this.currentQuery = "";
    this.routeToState = null;
    this.stateToRoute = null;
    this.viewMode = "list"
    this.htmlHelper = null;
    this.isMobile = this.checkIsMobile();

    this.toggleRefinementsNames = new Set(["meta.custom.event_venue"]);

    // Data Store
    this.venueDataStore = new Map();

    // Only apply URL-driven geo params once per value so map zoom / refineOnMapMove is not reset every search.
    this._lastUrlGeoSync = { bboxParam: null, placeQuery: null, aroundKey: null };
    // After the user pans/zooms, stop forcing URL geo onto InstantSearch (lets refineOnMapMove work).
    this.userHasRefinedMap = false;
    this.mapUserInteractionBound = false;
    this.ignoreUserMapGesturesUntil = 0;

    // Functions
    this.changeView = this.changeView.bind(this);
    this.renderViewButton = this.renderViewButton.bind(this);


    this.STORE_DEFAULT_LANGUAGE = window.AlgoliaAppSettingsHelper.STORE_DEFAULT_LANGUAGE ?? "en";
    this.currentStoreLanguage = this.getAttribute("current-store-language") || this.STORE_DEFAULT_LANGUAGE;
    this.pendingMapViewportUpdate = false;
    this.geoSearchWidgetInitialized = false;
    this.mapPinOverlaysById = new Map();
    this.mapAllPinsRequestId = 0;
    this.mapPinsIdleListenerBound = false;
    this.lastMapPinsRequestKey = "";
    this.mapPinsRequestKeyInFlight = "";
    this.mapProjectionOverlay = null;

    this.isApplyingProgrammaticMapMove = false;
    this.skipNextGeoBootstrap = false;
    
  }

  connectedCallback() {
    document.addEventListener('algolia.hooks.initialize', () => {
      this.render();
    });

    // Remove original behavior on scroll
    document.addEventListener('theme:scroll', (e) => {
      e.stopImmediatePropagation();
    }, true);

    let lastScroll = 0;
    // Define your breakpoint for "mobile"
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    this.setupViewportListener();

    function handleScroll() {
      const currentScroll = window.scrollY;

      if (Math.abs(currentScroll - lastScroll) < 5) return;

      const btnScrollToTop = document.querySelector('[data-scroll-top-button]');
      const viewModeButton = document.getElementById("guide-view-mode");
      const footer = document.querySelector('footer'); // Selecciona el footer

      if (!viewModeButton) return;


      const footerRect = footer?.getBoundingClientRect();
      const isFooterVisible = footerRect && footerRect.top < window.innerHeight && footerRect.bottom >= 0;

      if (isFooterVisible) {
        viewModeButton.classList.add("fade-out");
      } else {
        viewModeButton.classList.remove("fade-out");
      }

      if (btnScrollToTop) {
        if (currentScroll > lastScroll) {
          btnScrollToTop.classList.remove("is-visible");
        } else {
          btnScrollToTop.classList.add("is-visible");
        }
      }

      lastScroll = currentScroll;
    }

    function handleThemeScroll(e) {
      e.stopImmediatePropagation();
    }

    function toggleScrollListener(e) {

      if (e.matches) {
        // Mobile: enable scroll listener
        window.addEventListener("scroll", handleScroll);
        window.addEventListener('theme:scroll', handleThemeScroll, true);
      } else {
        // Desktop: disable scroll listener
        window.removeEventListener("scroll", handleScroll);
        window.removeEventListener('theme:scroll', handleThemeScroll, true);
      }
    }


    toggleScrollListener(mediaQuery);
    mediaQuery.addEventListener("change", toggleScrollListener);



    // Listen changes from custom-facets
    document.addEventListener('facet-value-changed', (event) => {
      const { name, value } = event.detail;
      if (!this.facets[name]?.length) return;

      let changedTo = "active";
      for (let index = 0; index < this.facets[name].length; index++) {
        const element = this.facets[name][index];
        if (element.value === value) {
          this.facets[name][index] = {
            ...element,
            isRefined: !(element.isRefined)
          }
          changedTo = element.isRefined ? "inactive" : "active";
          break;
        }
      }

      const linkedLabel = document.querySelector(`[data-label-id="custom-facet-label-${name}"]`);
      if (linkedLabel) {
        // Update number of active filter in custom-facet label
        const facetTitle = linkedLabel.getAttribute("data-facet-title");
        const currentFilterNumber = this.facets[name].filter((f) => f.isRefined === true)?.length ?? 0
        linkedLabel.textContent = facetTitle + `${currentFilterNumber > 0 ? ` (${currentFilterNumber})` : ''}`

        // Update styles of custom-facet container
        const customFacetContainer = linkedLabel.closest('.custom-facet');
        if (customFacetContainer) {
          customFacetContainer.classList.toggle("active", currentFilterNumber > 0);
        }
      }

      const activeFacetValues = this.facets[name].filter((e) => e.value === value)?.map((e) => `[data-facet-id="${name}--${value}"]`);
      if (activeFacetValues.length) {
        const customFilterElements = document.querySelectorAll(activeFacetValues.join(","))
        if (!customFilterElements?.length) return;
        customFilterElements.forEach((e) => e.setAttribute("facet-status", changedTo))
      }

    });

    document.addEventListener("facet-reset-refinements", (event) => {
      const activeFacets = document.querySelectorAll('custom-algolia-facet[facet-status="active"]');
      if (activeFacets.length) {
        activeFacets.forEach(facet => {
          const facetName = facet.getAttribute("facet-name")
          const linkedLabel = document.querySelector(`[data-label-id="custom-facet-label-${facetName}"]`);
          if (linkedLabel) {
            const facetTitle = linkedLabel.getAttribute("data-facet-title");
            linkedLabel.textContent = facetTitle;
            const customFacetContainer = linkedLabel.closest('.custom-facet');
            if (customFacetContainer) {
              customFacetContainer.classList.remove("active");
            }
          }
          facet.setAttribute('facet-status', 'inactive');
        });
      }
      const eventFilterToggles = document.querySelectorAll('[id^="toggle-refinement-event"]');
      eventFilterToggles.forEach(eventFilterToggle => {
        const currentToggleValue = eventFilterToggle.querySelector('input[type="checkbox"]');

        if (currentToggleValue) {
          currentToggleValue.checked = false;
          eventFilterToggle.setAttribute("data-status", "inactive");
          eventFilterToggle.classList.remove("active");
        }
      });

    })

    // Clear specific refinement
    document.addEventListener("facet-reset", (event) => {
      const { facetName } = event.detail;
      if (!facetName) return;
      this.resetRefinement(facetName)
    })

    // Close dropdowns when clicked outside
    document.addEventListener('click', function (e) {
      const clickedInsideFacet = e.target.closest('.custom-facet');
      if (!clickedInsideFacet) {
        // Close all dropdowns
        document.querySelectorAll('.modal-toggle').forEach(toggle => {
          toggle.checked = false;
        });
      }
    });

    document.addEventListener("update-facet-count", (event) => {
      // console.log("=======UPDATE FACET COUNT======", event.detail);
      const facetsCount = event.detail?.updatedFacetsCount
      const allFacets = event.detail?.facetsOrigin
      const facetName = event.detail?.facetName;
      if (!facetsCount || !facetName || !allFacets) return;
      for (let idx = 0; idx < allFacets.length; idx++) {
        const element = allFacets[idx];
        const facetId = `${facetName}--${element.value}`;

        const newCount = facetsCount.find((f) => f.value === element.value)?.count ?? 0;
        const htmlElementCount = document.querySelector(`[data-cf-id-count="${facetId}-count"]`)
        if (htmlElementCount) {
          // facet-total-count
          const customFacetElement = document.querySelector(`custom-algolia-facet[data-facet-id="${facetId}"]`)
          if (customFacetElement) {
            customFacetElement.setAttribute("facet-total-count", newCount)
          }
          htmlElementCount.textContent = `(${newCount})`;
        }

      }

    });
  }

  checkIsMobile() {
    return window.matchMedia("(max-width: 768px)").matches;
  }

  setupViewportListener() {
    const mq = window.matchMedia("(max-width: 768px)");

    mq.addEventListener("change", () => {
      this.handleResizeMode();
      this.handleViewModeResize();
    });
  }

  handleResizeMode() {
    this.isMobile = this.checkIsMobile();
  }

  handleViewModeResize() {
    if (!this.isMobile && this.viewMode === "map") {
      // Disable mobile map view in desktop
      this.disableMobileMapMode();
      this.setViewportMode();
    }
  }


  render() {
    algoliaShopify.hooks?.registerHook('beforeInstantSearchMainTemplate', (_defaultTemplate, data, html) => {
      if (this.htmlHelper === null) {
        this.htmlHelper = html
      }
      return this._renderMainTemplate(_defaultTemplate, data, html)
    });
    algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', (_defaultTemplate, hit, html, components, trackSearchAttribution) => {
      return this._renderHitTemplate(_defaultTemplate, hit, html, components, trackSearchAttribution)
    })
    algoliaShopify.hooks.registerHook('beforeInstantSearchNoResultTemplate', (_defaultTemplate, html) => {
      return this._renderNoResultsTemplate(_defaultTemplate, html)
    });
    algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', (_defaultTemplate, data, html) => {
      return this._renderSearchStatsTemplate(_defaultTemplate, data, html)
    })

    algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', () => {
      return this._renderCustomWidgets()
    });

    algoliaShopify.hooks.registerHook('beforeInstantSearchConfigurationOptions', (options) => {
      options.routing = false;
      // Set algolia index name based on the current language
      options.indexName = window.AlgoliaAppSettingsHelper.getIndexName(this.currentStoreLanguage);

      options.searchFunction = async (helper) => {
        const page = helper.getPage(); // Retrieve the current page
        const urlParams = new URLSearchParams(window.location.search);
        const bboxParam = urlParams.get('bbox');
        const viewModeParam = urlParams.get('viewMode');
        let country = urlParams.get('country');
        const aroundLatLng = urlParams.get('aroundLatLng');
        const aroundRadius = urlParams.get('aroundRadius');
        const geoScope = urlParams.get('geoScope');
        let query = urlParams.get("q");
        // Country searches (Australia, USA, UK): filter by country metafield only.
        // Google country viewports as insideBoundingBox often miss valid venue _geoloc.
        const isCountryScope = geoScope === 'country';

        const boundingFromState = helper.state?.insideBoundingBox;
        const hasBoundingFromState = boundingFromState !== undefined 
        const shouldSkipBootstrapThisCycle = this.skipNextGeoBootstrap === true;
        if (shouldSkipBootstrapThisCycle) {
          this.skipNextGeoBootstrap = false;
        }
        
    
        let searchHelper = helper.setPage(page);
        const searchParams = {
          hitsPerPage: this.HITS_PER_PAGE
        };

        let shouldApplyMapViewport = false;
        window.mapCustomBbbox = null;
        window.mapCustomAroundLatLng = null;

        this.currentQuery = urlParams.get("query") ?? urlParams.get("q") ?? "";

        if (viewModeParam) {
          this.viewMode = viewModeParam;
          this.setViewMode(viewModeParam);
        }

        // Handle location parameter with Google Places API (once per URL `q` so map refinements are not cleared on every search).
        if (query && this._lastUrlGeoSync.placeQuery !== query) {
          this._lastUrlGeoSync.placeQuery = query;
          try {

            const suggestions = await getGooglePlacesSuggestions(query);
            const matchingSuggestion = findMatchingSuggestion(suggestions, query);
            if (matchingSuggestion?.placePrediction?.placeId) {
              const placeData = await getPlaceDetails(matchingSuggestion.placePrediction.placeId);
              const isCountryPlace = (placeData.types || []).includes("country");

              if (placeData.viewport) {
                const mapBounds = viewportToMapBounds(placeData.viewport);
                if (mapBounds) {
                  window.mapCustomBbbox = mapBoundsToSerializedBBox(mapBounds);
                  // Country place: camera only. City/state: Algolia insideBoundingBox too.
                  if (!isCountryPlace) {
                    searchParams.insideBoundingBox = [mapBoundsToAlgoliaBoundingBox(mapBounds)];
                  }
                  shouldApplyMapViewport = true;

                }
              }

              if (placeData.addressComponents?.length) {
                const countryFromPlace = placeData.addressComponents.find((a) => a.types?.includes("country"));
                if (countryFromPlace) {
                  searchParams.filters = `meta.custom.country: "${countryFromPlace.longText}"`;
                }
              }
              if (placeData.formattedAddress) {
                if (placeData.formattedAddress == 'Melbourne' || placeData.formattedAddress.includes('Melbourne VIC')) {
                  const mapPoint = `${placeData.location.latitude},${placeData.location.longitude}`;
                  searchParams.aroundLatLng = mapPoint
                  searchParams.aroundRadius = '150000'
                  delete searchParams.insideBoundingBox
                  window.mapCustomBbbox = null;
                  window.mapCustomAroundLatLng = mapPoint;
                } else {
                  window.mapCustomAroundLatLng = null;
                }
                searchHelper.setQueryParameter("query", placeData.formattedAddress);
                const input = document.querySelector('input[class*="aa-Input"]');
                if (input) {
                  input.value = placeData.formattedAddress;
                }
              }

              searchHelper.setQueryParameter("query", "");


            } else {
              // Fallback: use location as query if no matching place found
              this.currentQuery = query;
            }
          } catch (e) {
            console.error('Error fetching place suggestions:', e);
            // Fallback: use location as query
            this.currentQuery = query;
          }
        }

        // Search filter: re-apply URL geo on every cycle until the user moves the map.
        // Camera still bootstraps only once via _lastUrlGeoSync.
        const aroundKey = aroundLatLng && aroundRadius ? `${aroundLatLng}|${aroundRadius}` : null;

        // New location search from URL → take back filter control from previous map gestures.
        if (bboxParam && this._lastUrlGeoSync.bboxParam !== bboxParam) {
          this.userHasRefinedMap = false;
        }
        if (aroundKey && this._lastUrlGeoSync.aroundKey !== aroundKey) {
          this.userHasRefinedMap = false;
        }

        const shouldForceUrlGeo = !this.userHasRefinedMap;

        if (shouldForceUrlGeo && bboxParam) {
          try {
            const mapBounds = normalizeMapBounds(bboxParam);
            if (mapBounds) {
              // Always keep place bounds for map camera.
              window.mapCustomBbbox = mapBoundsToSerializedBBox(mapBounds);
              // City/state: also filter Algolia by bbox. Country: country filter only
              // (Australia/USA viewports as insideBoundingBox drop valid venues).
              if (!isCountryScope) {
                searchParams.insideBoundingBox = [mapBoundsToAlgoliaBoundingBox(mapBounds)];
              } else {
                searchParams.insideBoundingBox = undefined;
              }

              if (this._lastUrlGeoSync.bboxParam !== bboxParam) {
                this._lastUrlGeoSync.bboxParam = bboxParam;
                shouldApplyMapViewport = !shouldSkipBootstrapThisCycle;
              }
            } else {
              console.warn("Invalid bbox format:", bboxParam);
            }
          } catch (error) {
            console.error("Error parsing bbox:", error);
          }
        } else if (hasBoundingFromState) {
          country = null;
        }

        if (shouldForceUrlGeo && aroundKey) {
          searchParams.aroundLatLng = aroundLatLng;
          searchParams.aroundRadius = aroundRadius;
          window.mapCustomAroundLatLng = aroundLatLng;

          if (this._lastUrlGeoSync.aroundKey !== aroundKey) {
            this._lastUrlGeoSync.aroundKey = aroundKey;
            shouldApplyMapViewport = !shouldSkipBootstrapThisCycle;
          }
        } else if (this.userHasRefinedMap) {
          // Let geoSearch's map bounds own the filter after user zoom/pan.
          searchParams.aroundLatLng = undefined;
          searchParams.aroundRadius = undefined;
          window.mapCustomAroundLatLng = null;
          country = null;
        } else if (!query) {
          window.mapCustomAroundLatLng = null;
        }

        // With URL geo re-applied (until map interaction), country can AND with bbox.
        // Previous bug: country alone after bbox was applied only once.
        if (country && !searchParams.filters) {
          searchParams.filters = `meta.custom.country: "${country}"`;
        }

        // if (urlParams.has(this.TOGGLE_REFINEMENT_URL_PARAM)) {
        //   helper.addDisjunctiveFacetRefinement(
        //     "meta.custom.event_venue",
        //     "true"
        //   );
      
        // }

        Object.entries(searchParams).forEach(([key, value]) => {
          searchHelper = searchHelper.setQueryParameter(key, value);
        });

        searchHelper = searchHelper.setPage(page);

        if (shouldApplyMapViewport) {
          this.queueMapViewportUpdate();
        }

        return searchHelper.search();


      }

      return options;
    });
  }


  whenGoogleMapsReady() {
    return new Promise((resolve, reject) => {
      // If already available
      if (window.google && window.google.maps && window.google.maps.OverlayView) {
        return resolve(window.google);
      }
      // Poll until loaded (simple approach)
      const t = setInterval(() => {
        if (window.google && window.google.maps && window.google.maps.OverlayView) {
          clearInterval(t);
          resolve(window.google);
        }
      }, 50);

      // Optional timeout
      setTimeout(() => {
        clearInterval(t);
        reject(new Error('Google Maps did not load in time'));
      }, 60000);
    });
  }


  getDataStore() {
    return this.venueDataStore;
  }

  getBTGImages() {
    return this.BTG_IMAGES;
  }

  getViewMode() {
    return this.viewMode;
  }

  getCurrentRootURL() {
    return this.CURRENT_ROOT_URL;
  }

  getCoravinLogo() {
    return this.CORAVIN_LOGO_IMAGE;
  }

  getMapPinConfig() {
    return this.MAP_PIN_CONFIG;
  }

  getAutocompleteWidget() {
    return document.getElementById("autocompleteCustom");
  }

   clearInitialGeoParamsFromUrl() {
    const url = new URL(window.location.href);
    const params = url.searchParams;
  
    const viewMode = params.get("viewMode");
  
    url.search = "";
  
    if (viewMode) {
      url.searchParams.set("viewMode", viewMode);
    }
  
    const nextUrl = `${url.pathname}${url.search}${url.hash || ""}`;
    window.history.replaceState(window.history.state, "", nextUrl);
  }

  queueMapViewportUpdate() {
    if (this.userHasRefinedMap) return;
    this.pendingMapViewportUpdate = true;
    this.scheduleMapViewportUpdate();
  }

  getGeoSearchMapInstance() {
    const indexName = window.AlgoliaAppSettingsHelper.getIndexName(this.currentStoreLanguage);
    return window.algoliaShopify?.instantsearch?.search?.renderState?.[indexName]?.geoSearch?.widgetParams?.renderState?.mapInstance;
  }

  bindMapUserInteraction(mapInstance) {
    if (!mapInstance || this.mapUserInteractionBound || typeof mapInstance.addListener !== "function") {
      return;
    }

    this.mapUserInteractionBound = true;

    const onUserMapGesture = () => {
      if (this.isApplyingProgrammaticMapMove) return;
      if (this.pendingMapViewportUpdate) return;
      if (Date.now() < this.ignoreUserMapGesturesUntil) return;
      if (!this._lastUrlGeoSync.bboxParam && !this._lastUrlGeoSync.aroundKey) return;
      this.userHasRefinedMap = true;
    };

    mapInstance.addListener("dragstart", onUserMapGesture);
    mapInstance.addListener("zoom_changed", onUserMapGesture);
  }

  getSearchResultGeoPoints() {
    const helper = window.algoliaShopify?.instantsearch?.search?.helper;
    const hits = helper?.lastResults?.hits || [];
    const points = [];

    hits.forEach((hit) => {
      const location = this.getHitGeoLocation(hit);
      if (location) points.push(location);
    });

    if (points.length) return points;

    this.venueDataStore.forEach((hit) => {
      const location = this.getHitGeoLocation(hit);
      if (location) points.push(location);
    });

    return points;
  }

  fitMapToResultPoints(mapInstance, points) {
    if (!mapInstance || !points?.length || !window.google?.maps) {
      return false;
    }

    const bounds = new window.google.maps.LatLngBounds();
    points.forEach((point) => {
      bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
    });

    // Single pin needs a small padded box or fitBounds zooms too far in.
    if (points.length === 1) {
      const { lat, lng } = points[0];
      bounds.extend(new window.google.maps.LatLng(lat + 0.05, lng + 0.05));
      bounds.extend(new window.google.maps.LatLng(lat - 0.05, lng - 0.05));
    }

    this.isApplyingProgrammaticMapMove = true;
    this.skipNextGeoBootstrap = true;
    this.ignoreUserMapGesturesUntil = Date.now() + 1000;

    mapInstance.fitBounds(bounds, { top: 80, right: 80, bottom: 80, left: 80 });

    window.google.maps.event.addListenerOnce(mapInstance, "idle", () => {
      const zoom = Number(mapInstance.getZoom?.());
      // Keep multi-venue country/city views readable (don't zoom into a single block).
      if (Number.isFinite(zoom) && zoom > 12) {
        mapInstance.setZoom(12);
      }
      this.isApplyingProgrammaticMapMove = false;
    });

    return true;
  }

  applyPendingMapViewport(mapInstance) {
    if (!this.pendingMapViewportUpdate || !mapInstance || this.userHasRefinedMap) {
      return false;
    }

    const helper = window.algoliaShopify?.instantsearch?.search?.helper;
    const searchCompleted = helper?.lastResults != null;
    const resultPoints = this.getSearchResultGeoPoints();

    // Prefer fitting to actual venue pins. Country viewports (USA) are huge and leave
    // pins clustered in one corner when the Guide only covers a few cities.
    if (resultPoints.length > 0) {
      if (this.fitMapToResultPoints(mapInstance, resultPoints)) {
        this.pendingMapViewportUpdate = false;
        this.bindMapUserInteraction(mapInstance);
        return true;
      }
    }

    // Wait for the first search response before falling back to the place viewport.
    if (!searchCompleted) {
      return false;
    }

    const activeBounds = normalizeMapBounds(window.mapCustomBbbox);
    const activeAroundLatLng = parseAroundLatLng(window.mapCustomAroundLatLng);
    // console.log("MAP LOADED========??", window.mapCustomBbbox ?? window.mapCustomAroundLatLng, activeBounds);

    if (activeBounds) {
      const bounds = new window.google.maps.LatLngBounds(
        new window.google.maps.LatLng(activeBounds.south, activeBounds.west),
        new window.google.maps.LatLng(activeBounds.north, activeBounds.east)
      );

      this.isApplyingProgrammaticMapMove = true;
      this.skipNextGeoBootstrap = true;
      this.ignoreUserMapGesturesUntil = Date.now() + 1000;

      // Balanced padding keeps search results centered (previous bottom:0 + large panBy
      // pushed pins toward the top of the map, e.g. Los Angeles).
      mapInstance.fitBounds(bounds, { top: 80, right: 80, bottom: 80, left: 80 });
      mapInstance.setCenter(bounds.getCenter());
    } else if (activeAroundLatLng && typeof mapInstance.setCenter === "function") {
      this.isApplyingProgrammaticMapMove = true;
      this.skipNextGeoBootstrap = true;
      this.ignoreUserMapGesturesUntil = Date.now() + 1000;
      mapInstance.setCenter(activeAroundLatLng);
    } else {
      return false;
    }

    this.pendingMapViewportUpdate = false;
    this.bindMapUserInteraction(mapInstance);
    return true;
  }

  scheduleMapViewportUpdate() {
    if (!this.pendingMapViewportUpdate || !window.google?.maps) {
      return false;
    }

    const mapInstance = this.getGeoSearchMapInstance();
    // console.log("MAP INSTANCE", mapInstance);
    if (!mapInstance) {
      return false;
    }

    this.bindMapUserInteraction(mapInstance);

    if (this.applyPendingMapViewport(mapInstance)) {
      return true;
    }

    if (this.mapViewportIdleListenerBound) {
      return true;
    }

    this.mapViewportIdleListenerBound = true;
    window.google.maps.event.addListenerOnce(mapInstance, "idle", () => {
      // console.log("========IDLE=====")
      this.mapViewportIdleListenerBound = false;
      this.applyPendingMapViewport(mapInstance);
    });

    return true;
  }

  getMapSearchParams() {
    const helper = window.algoliaShopify?.instantsearch?.search?.helper;
    const state = helper?.state;
    if (!state) return null;

    const mapInstance = this.getGeoSearchMapInstance();
    const insideBoundingBox = this.getMapViewportInsideBoundingBox(mapInstance);
    if (!insideBoundingBox) return null;

    const queryParams = typeof state.getQueryParams === "function"
      ? state.getQueryParams()
      : { ...state };

    const {
      page,
      hitsPerPage,
      maxValuesPerFacet,
      facets,
      disjunctiveFacets,
      hierarchicalFacets,
      facetsRefinements,
      disjunctiveFacetsRefinements,
      hierarchicalFacetsRefinements,
      numericRefinements,
      tagRefinements,
      aroundLatLng,
      aroundLatLngViaIP,
      aroundRadius,
      aroundPrecision,
      insideBoundingBox: _stateInsideBoundingBox,
      ...searchParams
    } = queryParams;

    return {
      ...searchParams,
      insideBoundingBox,
      page: 0,
      hitsPerPage: this.MAP_HITS_PER_PAGE,
      attributesToRetrieve: this.MAP_PIN_ATTRIBUTES,
      analytics: false,
      clickAnalytics: false
    };
  }

  scheduleAllMapPinsRender() {
    window.clearTimeout(this.mapAllPinsRenderTimer);
    this.mapAllPinsRenderTimer = window.setTimeout(() => {
      this.renderAllMapPins();
    }, 250);
  }

  bindMapPinsIdleRefresh(mapInstance) {
    if (!mapInstance || this.mapPinsIdleListenerBound || typeof mapInstance.addListener !== "function") {
      return;
    }

    this.mapPinsIdleListenerBound = true;
    this.bindMapUserInteraction(mapInstance);
    mapInstance.addListener("idle", () => {
      this.isApplyingProgrammaticMapMove = false;
      this.scheduleAllMapPinsRender();
    });
  }

  clearAllMapPins() {
    this.mapPinOverlaysById.forEach((overlay) => overlay.setMap(null));
    this.mapPinOverlaysById.clear();
    this.lastMapPinsRequestKey = "";
    this.mapPinsRequestKeyInFlight = "";
  }

  shouldRenderMapPins() {
    const mainBlock = document.getElementById("algolia-main-content");
    const viewMode = mainBlock?.getAttribute("data-view-mode") || this.viewMode;
    if (viewMode !== "map") return false;

    const geoSearchElement = document.getElementById("geo-search");
    if (!geoSearchElement) return false;

    const rect = geoSearchElement.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  getMapViewportInsideBoundingBox(mapInstance) {
    const bounds = mapInstance?.getBounds?.();
    if (!bounds) return null;

    const southWest = bounds.getSouthWest?.();
    const northEast = bounds.getNorthEast?.();
    if (!southWest || !northEast) return null;

    const mapBounds = normalizeMapBounds([
      southWest.lat(),
      southWest.lng(),
      northEast.lat(),
      northEast.lng()
    ]);

    if (!mapBounds) return null;
    return [mapBoundsToAlgoliaBoundingBox(mapBounds).map((value) => Number(value.toFixed(5)))];
  }

  getHitGeoLocation(hit) {
    const geoloc = Array.isArray(hit?._geoloc) ? hit._geoloc[0] : hit?._geoloc;
    const lat = Number(geoloc?.lat);
    const lng = Number(geoloc?.lng);

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    return { lat, lng };
  }

  normalizeMapHit(hit) {
    const id = String(hit?.id || hit?.objectID || "");
    if (!id) return null;

    let image = hit?.image;
    try {
      image = image || algoliaShopify.helpers.renderImage(hit, 100);
    } catch (error) {
      image = image || "";
    }

    return {
      ...hit,
      id,
      image
    };
  }

  createMapPinOverlay(hit, mapInstance) {
    const location = this.getHitGeoLocation(hit);
    if (!location || !window.google?.maps?.OverlayView) return null;

    const venueId = String(hit.id);
    const overlay = new window.google.maps.OverlayView();
    const latLng = new window.google.maps.LatLng(location.lat, location.lng);
    let container = null;

    overlay.onAdd = () => {
      container = document.createElement("div");
      container.className = "custom-algolia-map-pin-overlay";
      container.style.position = "absolute";
      container.style.transform = "translate(-50%, -100%)";
      container.style.zIndex = "1";

      const pin = document.createElement("custom-algolia-map-pin");
      pin.setAttribute("data-venue-id", venueId);
      pin.setPinData?.({
        venueData: hit,
        btgImages: this.BTG_IMAGES,
        rootUrl: this.CURRENT_ROOT_URL,
        mapPinImage: this.CORAVIN_LOGO_IMAGE,
        mapPinConfig: this.MAP_PIN_CONFIG
      });
      container.appendChild(pin);

      const panes = overlay.getPanes();
      panes?.overlayMouseTarget?.appendChild(container);
    };

    overlay.draw = () => {
      if (!container) return;

      const projection = overlay.getProjection();
      const point = projection?.fromLatLngToDivPixel(latLng);

      if (!point) return;
      container.style.left = `${point.x}px`;
      container.style.top = `${point.y}px`;
    };

    overlay.onRemove = () => {
      container?.remove();
      container = null;
    };

    overlay.setMap(mapInstance);
    return overlay;
  }

  getMapPixelProjection(mapInstance) {
    if (!mapInstance || !window.google?.maps?.OverlayView) return null;

    if (!this.mapProjectionOverlay || this.mapProjectionMapInstance !== mapInstance) {
      if (this.mapProjectionOverlay) {
        this.mapProjectionOverlay.setMap(null);
      }

      const overlay = new window.google.maps.OverlayView();
      overlay.onAdd = () => {};
      overlay.draw = () => {};
      overlay.onRemove = () => {};
      overlay.setMap(mapInstance);

      this.mapProjectionOverlay = overlay;
      this.mapProjectionMapInstance = mapInstance;
    }

    return this.mapProjectionOverlay.getProjection?.() || null;
  }

  getMapClusterCellSize(mapInstance) {
    const zoom = Number(mapInstance?.getZoom?.()) || 0;
    return zoom >= 16
      ? 36
      : zoom >= 13
        ? 46
        : zoom >= 9
          ? this.MAP_CLUSTER_BASE_CELL_SIZE
          : 72;
  }

  buildMapDisplayItems(hits, mapInstance) {
    const projection = this.getMapPixelProjection(mapInstance);
    if (!projection) {
      return hits.map((hit) => ({
        id: `pin:${hit.id}`,
        type: "pin",
        hit
      }));
    }

    const cellSize = this.getMapClusterCellSize(mapInstance);
    const groups = new Map();

    hits.forEach((hit) => {
      const location = this.getHitGeoLocation(hit);
      if (!location) return;

      const point = projection.fromLatLngToDivPixel(
        new window.google.maps.LatLng(location.lat, location.lng)
      );
      if (!point) return;

      const cellX = Math.floor(point.x / cellSize);
      const cellY = Math.floor(point.y / cellSize);
      const cellKey = `${cellX}:${cellY}`;

      if (!groups.has(cellKey)) {
        groups.set(cellKey, {
          cellKey,
          hits: [],
          locations: [],
          latTotal: 0,
          lngTotal: 0
        });
      }

      const group = groups.get(cellKey);
      group.hits.push(hit);
      group.locations.push(location);
      group.latTotal += location.lat;
      group.lngTotal += location.lng;
    });

    return Array.from(groups.values()).flatMap((group) => {
      if (group.hits.length <= this.MAP_CLUSTER_THRESHOLD) {
        return group.hits.map((hit) => ({
          id: `pin:${hit.id}`,
          type: "pin",
          hit
        }));
      }

      const sortedIds = group.hits.map((hit) => hit.id).sort();
      return {
        id: `cluster:${group.cellKey}:${sortedIds.join("_")}`,
        type: "cluster",
        count: group.hits.length,
        location: {
          lat: group.latTotal / group.hits.length,
          lng: group.lngTotal / group.hits.length
        },
        locations: group.locations
      };
    });
  }

  createMapClusterOverlay(cluster, mapInstance) {
    const location = cluster?.location;
    if (!location || !window.google?.maps?.OverlayView) return null;

    const overlay = new window.google.maps.OverlayView();
    const latLng = new window.google.maps.LatLng(location.lat, location.lng);
    let container = null;

    overlay.onAdd = () => {
      container = document.createElement("button");
      container.type = "button";
      container.className = "custom-algolia-map-cluster-overlay";
      container.textContent = cluster.count;
      container.style.position = "absolute";
      container.style.transform = "translate(-50%, -50%)";
      container.setAttribute("aria-label", `${cluster.count} venues`);

      container.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.zoomToMapCluster(cluster, mapInstance);
      });

      const panes = overlay.getPanes();
      panes?.overlayMouseTarget?.appendChild(container);
    };

    overlay.draw = () => {
      if (!container) return;

      const projection = overlay.getProjection();
      const point = projection?.fromLatLngToDivPixel(latLng);

      if (!point) return;
      container.style.left = `${point.x}px`;
      container.style.top = `${point.y}px`;
    };

    overlay.onRemove = () => {
      container?.remove();
      container = null;
    };

    overlay.setMap(mapInstance);
    return overlay;
  }

  zoomToMapCluster(cluster, mapInstance) {
    if (!cluster?.locations?.length || !mapInstance || !window.google?.maps) return;

    const bounds = new window.google.maps.LatLngBounds();
    cluster.locations.forEach((location) => {
      bounds.extend(new window.google.maps.LatLng(location.lat, location.lng));
    });

    const northEast = bounds.getNorthEast();
    const southWest = bounds.getSouthWest();
    const isSinglePoint = northEast.equals?.(southWest);

    if (isSinglePoint) {
      mapInstance.setCenter(cluster.location);
      mapInstance.setZoom(Math.min((Number(mapInstance.getZoom?.()) || 0) + 2, 19));
      return;
    }

    mapInstance.fitBounds(bounds, { top: 80, right: 80, bottom: 80, left: 80 });
  }

  createMapDisplayOverlay(item, mapInstance) {
    if (item?.type === "cluster") {
      return this.createMapClusterOverlay(item, mapInstance);
    }

    return this.createMapPinOverlay(item.hit, mapInstance);
  }

  async fetchAllMapHits(params, requestId) {
    const helper = window.algoliaShopify?.instantsearch?.search?.helper;
    const hits = [];
    let page = 0;
    let nbPages = 1;

    if (typeof helper?.searchOnce === "function") {
      do {
        if (requestId !== this.mapAllPinsRequestId) return null;

        const response = await helper.searchOnce({
          ...params,
          page
        });
        const content = response?.content || {};
        hits.push(...(content.hits || []));

        const totalPages = Number(content.nbPages);
        const totalHits = Number(content.nbHits);
        nbPages = Number.isFinite(totalPages) && totalPages > 0
          ? totalPages
          : Math.max(Math.ceil(totalHits / this.MAP_HITS_PER_PAGE), 1);
        page += 1;
      } while (page < nbPages);

      return hits;
    }

    const { app_id, search_api_key } = window.algoliaShopify.config;
    const { algoliasearch } = window.algoliaShopify.externals;
    const searchClient = algoliasearch(app_id, search_api_key);
    const indexName = window.AlgoliaAppSettingsHelper.getIndexName(this.currentStoreLanguage);

    do {
      if (requestId !== this.mapAllPinsRequestId) return null;

      const response = await searchClient.search([{
        indexName,
        params: {
          ...params,
          page
        }
      }]);
      const result = response?.results?.[0] || {};
      hits.push(...(result.hits || []));

      const totalPages = Number(result.nbPages);
      const totalHits = Number(result.nbHits);
      nbPages = Number.isFinite(totalPages) && totalPages > 0
        ? totalPages
        : Math.max(Math.ceil(totalHits / this.MAP_HITS_PER_PAGE), 1);
      page += 1;
    } while (page < nbPages);

    return hits;
  }

  renderMapPinOverlayBatch(displayItems, mapInstance, requestId) {
    return new Promise((resolve) => {
      const scheduleFrame = window.requestAnimationFrame || ((callback) => window.setTimeout(callback, 0));
      let index = 0;

      const renderBatch = () => {
        if (requestId !== this.mapAllPinsRequestId) {
          resolve();
          return;
        }

        const end = Math.min(index + this.MAP_PIN_BATCH_SIZE, displayItems.length);
        for (; index < end; index += 1) {
          const displayItem = displayItems[index];
          if (this.mapPinOverlaysById.has(displayItem.id)) continue;

          const overlay = this.createMapDisplayOverlay(displayItem, mapInstance);
          if (overlay) {
            this.mapPinOverlaysById.set(displayItem.id, overlay);
          }
        }

        if (index < displayItems.length) {
          scheduleFrame(renderBatch);
          return;
        }

        resolve();
      };

      scheduleFrame(renderBatch);
    });
  }

  async renderAllMapPins() {
    if (!this.shouldRenderMapPins()) {
      this.clearAllMapPins();
      return;
    }

    const mapInstance = this.getGeoSearchMapInstance();
    if (!mapInstance || !window.google?.maps) return;

    this.bindMapPinsIdleRefresh(mapInstance);

    const params = this.getMapSearchParams();
    if (!params) return;

    const requestKey = JSON.stringify(params);
    if (requestKey === this.lastMapPinsRequestKey) return;
    if (requestKey === this.mapPinsRequestKeyInFlight) return;

    const requestId = ++this.mapAllPinsRequestId;
    this.mapPinsRequestKeyInFlight = requestKey;

    try {
      const hits = await this.fetchAllMapHits(params, requestId);
      if (requestId !== this.mapAllPinsRequestId) return;
      if (!hits) return;

      const normalizedHits = [];
      const seenIds = new Set();

      hits.forEach((hit) => {
        const mapHit = this.normalizeMapHit(hit);
        if (!mapHit || seenIds.has(mapHit.id) || !this.getHitGeoLocation(mapHit)) return;

        seenIds.add(mapHit.id);
        this.venueDataStore.set(mapHit.id, mapHit);
        normalizedHits.push(mapHit);
      });

      const displayItems = this.buildMapDisplayItems(normalizedHits, mapInstance);
      const nextIds = new Set();
      const displayItemsToAdd = [];

      displayItems.forEach((displayItem) => {
        nextIds.add(displayItem.id);

        if (!this.mapPinOverlaysById.has(displayItem.id)) {
          displayItemsToAdd.push(displayItem);
        }
      });

      this.mapPinOverlaysById.forEach((overlay, id) => {
        if (!nextIds.has(id)) {
          overlay.setMap(null);
          this.mapPinOverlaysById.delete(id);
        }
      });

      await this.renderMapPinOverlayBatch(displayItemsToAdd, mapInstance, requestId);
      if (requestId !== this.mapAllPinsRequestId) return;

      this.lastMapPinsRequestKey = requestKey;
    } catch (error) {
      console.warn("Unable to render all Algolia map pins:", error);
    } finally {
      if (this.mapPinsRequestKeyInFlight === requestKey) {
        this.mapPinsRequestKeyInFlight = "";
      }
    }
  }

  async initAlgoliaGeo() {
    try {
      await this.whenGoogleMapsReady();

      // console.log("Google is ready???===", window.google);
      // console.log("Algolia Object===", window.algoliaShopify);

      const { geoSearch } = window.instantsearch.widgets;
      if (!geoSearch) throw new Error('geoSearch not available on instantsearch.widgets');

      const self = this;

      const instaAlgolia = window.algoliaShopify.instantsearch.search;

      if (!instaAlgolia) {
        return;
      }

      if (this.geoSearchWidgetInitialized) {
        this.scheduleMapViewportUpdate();
        this.scheduleAllMapPinsRender();
        return;
      }


      const geoSearchWidget = geoSearch({
        container: '#geo-search',
        googleReference: window.google,
        initialZoom: 20,
        enableRefineOnMapMove: true,
        mapOptions: {
          // mapTypeId: window.google.maps.MapTypeId.SATELLITE,
          streetViewControl: false,
          scrollwheel: true,
          gestureHandling: "greedy",
          // Camera control (gmp-internal-*): default is lower-left; place at top right (LTR).
          ...(window.google?.maps?.ControlPosition
            ? {
                cameraControl: true,
                cameraControlOptions: {
                  position:
                    window.google.maps.ControlPosition.BLOCK_START_INLINE_END ??
                    window.google.maps.ControlPosition.TOP_RIGHT,
                },
              }
            : {}),
          styles: [
            {
              "featureType": "all",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "weight": "2.00"
                }
              ]
            },
            {
              "featureType": "all",
              "elementType": "geometry.stroke",
              "stylers": [
                {
                  "color": "#9c9c9c"
                }
              ]
            },
            {
              "featureType": "all",
              "elementType": "labels.text",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "landscape",
              "elementType": "all",
              "stylers": [
                {
                  "color": "#f2f2f2"
                }
              ]
            },
            {
              "featureType": "landscape",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "color": "#ffffff"
                }
              ]
            },
            {
              "featureType": "landscape.man_made",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "color": "#ffffff"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "all",
              "stylers": [
                {
                  "saturation": -100
                },
                {
                  "lightness": 45
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "color": "#eeeeee"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#7b7b7b"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "labels.text.stroke",
              "stylers": [
                {
                  "color": "#ffffff"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "simplified"
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "transit",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "all",
              "stylers": [
                {
                  "color": "#46bcec"
                },
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "color": "#c8d7d4"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#070707"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "labels.text.stroke",
              "stylers": [
                {
                  "color": "#ffffff"
                }
              ]
            }
          ]
        },
        templates: {
          HTMLMarker(data, { html }) {
            const { id } = data;

            if (id) {
              self.venueDataStore.set(String(id), data);
            }
            return html`<span hidden></span>`;
          },
        },
        builtInMarker: {
          createOptions(item) {
            return {
              title: item.name,
            };
          },
          events: {
            click({ event, item, marker, map }) {
              // console.log("clicked venue", item?.title, item?.id);
            },
          },
        },
      })
      if (instaAlgolia) {
        instaAlgolia.addWidgets([
          geoSearchWidget
        ])
        this.geoSearchWidgetInitialized = true;

        if (typeof instaAlgolia.on === "function") {
          instaAlgolia.on("render", () => {
            this.scheduleMapViewportUpdate();
            this.scheduleAllMapPinsRender();
          });
        }

        this.scheduleMapViewportUpdate();
        this.scheduleAllMapPinsRender();
      }

      // add widget to your instantsearch instance as you normally would
      // search.addWidgets([ widget ]) or instantsearch().addWidgets(...)
    } catch (err) {
      console.error('Failed to init Algolia geoSearch:', err);
    }
  }



  _renderCustomWidgets() {
    const clearRefinementsText = this.CLEAR_FILTERS_TEXT;
    const { clearRefinements } = window.algoliaShopify.externals.widgets;


    // console.log("GEO SEARCH=====", window.algoliaShopify, window.google);

    this.initAlgoliaGeo();
    // Create the render function
    const { connectGeoSearch } = window.instantsearch.connectors;
    const { app_id, search_api_key } = window.algoliaShopify.config;
    const { algoliasearch } = window.algoliaShopify.externals;
    const search = instantsearch({
      indexName: "shopify_products",
      searchClient: algoliasearch(app_id, search_api_key),

    });


    const widgets = [];

    // Add custom facets
    const customFacets = this._createCustomFacetsWidgets()
    widgets.push(...customFacets)


    // Add custom current facets 
    const customCurrentRefinements = this._createCurrentFacetsWidget()

    widgets.push(
      clearRefinements({
        container: "#custom-clear-refinements",
        templates: {
          resetLabel({ hasRefinements }, { html }) {
            return html`<span class="clear-refinements-text">${clearRefinementsText}</span>`;
          },
        }
      }),
      customCurrentRefinements({
        container: document.querySelector('#current-refinements')
      })
    )

    return [...widgets];
  }



  _createCustomFacetsWidgets() {
    const customFacets = []
    const { refinementList } = window.algoliaShopify.externals.widgets;
    const facets = window.algoliaShopify.facets || [];

    const btgImagesSrc = this.BTG_IMAGES;
    const btgRatingTexts = this.BTG_RATING_TEXTS;

    const toggleRefinementsNames = this.toggleRefinementsNames;

  
    const { toggleRefinement } = window.instantsearch.widgets;

    const filteredFacets = facets.filter((f) => {
      if (f.type !== "hidden") {
        return true
      }
      return false
    });

    
    filteredFacets.forEach(facet => {
      const attr = facet.name;
      if (!this.facets[facet.name]) this.facets[facet.name] = []

      const facetContainerElement = document.getElementById(`${facet.name}--facets-container`)

      customFacets.push(
        refinementList({
          container: facetContainerElement,
          attribute: attr,
          operator: "or",
          limit: 200,
          cssClasses: {
            root: 'MyCustomRefinementList'
          },
          transformItems: items => {
            // console.log(`TransformItems: ${facet.name}==== `, items);

            this.facetsCounts[facet.name] = [...items];

            // Save all facet values on first render
            if (this.initialRender[facet.name] !== true && !this.facets[facet.name].length) {
              const _items = items.map((i) => ({
                ...i,
                label: i.label,
                value: i.value,
                isRefined: false,
                count: i.count
              }))
              this.facets[facet.name] = _items
              this.initialRender[facet.name] = true
            }


            this.facets[facet.name].forEach((facetItem, idx) => {
              const updatedItem = items.find((item) => item.value === facetItem.value)
              if (updatedItem) {
                const count = this.facets[facet.name][idx].count;
                this.facets[facet.name][idx] = {
                  ...updatedItem,
                  count: count
                }
              }
            })
            // console.log("Facets=====", this.facets);
            return this.facets[facet.name];
          },
          templates: {
            item(item, { html }) {
              const { url, label, count, isRefined, value } = item;
              if(toggleRefinementsNames.has(facet.name)) return html ``;
              return html`
                <custom-algolia-facet 
                    data-facet-id="${facet.name}--${value}" 
                    facet-name="${facet.name}" 
                    facet-value="${value}" 
                    facet-label="${label}" 
                    facet-status="${isRefined ? "active" : "inactive"}"
                    facet-total-count="${count}"
                    data-url="${url}"
                    btg-images="${btgImagesSrc}"
                    btg-rating-texts='${JSON.stringify(btgRatingTexts)}'
                >
                </custom-algolia-facet>
                `;
            },
          },

        })
      );
    });

    const toggleRefinements = facets.filter(facet => toggleRefinementsNames.has(facet.name));
    const urlParams = new URLSearchParams(window.location.search);
    const toggleRefinementUrlParam = this.TOGGLE_REFINEMENT_URL_PARAM;
    
    toggleRefinements.forEach((toggleFacet) =>{
      const container = document.getElementById(
          `toggle-refinement-event-${toggleFacet.name}`
        );
        if (!container) return;
        customFacets.push(
          toggleRefinement({
            container,
            attribute: toggleFacet.name,
            templates: {
              labelText({ count, isRefined }, { html }) {
                return html`
                  <custom-facet-modal 
                    facet-name="${toggleFacet.name}" 
                    facet-title="${toggleFacet.title}"
                    is-toggle-refinement="true"
                    is-refined="${urlParams.has(toggleRefinementUrlParam)}"
                  >
                  </custom-facet-modal>
                `;
              },
            },
          })
        );
    })

    return customFacets;
  }

  _createCurrentFacetsWidget() {
    const { connectCurrentRefinements } = window.algoliaShopify.externals.connectors;
    const createDataAttribtues = refinement =>
      Object.keys(refinement)
        .map(key => `data-${key}="${refinement[key]}"`)
        .join(' ');

    const renderListItem = item => {
      let facetTitle = item.label
      const facetObj = window.algoliaShopify?.facets?.find((f) => f.name === item.label)
      if (facetObj?.title) {
        facetTitle = facetObj.title;
      }

      return `
          <li class="custom-current-refinement-item">
            <span class="custom-current-refinement-title">${facetTitle}:</span>
            <ul class="custom-current-refinement-list">
              ${item.refinements
          .map(
            refinement =>
              `<li class="custom-current-refinement-value">
                      <button style="font-size:2rem;" ${createDataAttribtues(refinement)}>×</button>
                      ${refinement.label}
                    </li>`
          )
          .join('')}
            </ul>
          </li>
        `;
    }


    const renderCurrentRefinements = (renderOptions, isFirstRender) => {
      const { items, refine, widgetParams } = renderOptions;

      if (!isFirstRender) {
        const clearRefinementButton = document.getElementById("custom-clear-refinements");
        if (clearRefinementButton) {
          clearRefinementButton.classList.toggle("active", items.length === 0)
        }

        // console.log("Items=======", this.facetsCounts);
        for (const [key, values] of Object.entries(this.facetsCounts)) {
          document.dispatchEvent(new CustomEvent('update-facet-count', {
            bubbles: true,
            composed: true,
            detail: {
              facetName: key,
              updatedFacetsCount: this.facetsCounts[key],
              facetsOrigin: this.facets[key]
            }
          }));
        }


        if (!items?.length) {
          // Reset all refinements
          const activeFacets = document.querySelectorAll('custom-algolia-facet[facet-status="active"]');
          const activeEventToggle = document.querySelector(
            '[id^="toggle-refinement-event"][data-status="active"]'
          );
          if (activeFacets?.length || activeEventToggle) {
            document.dispatchEvent(new CustomEvent("facet-reset-refinements", {
              bubbles: true,
              composed: true,

            }))
          }
        } else {
          for (const [key, values] of Object.entries(this.facets)) {
            const newActivateFacetElements = items.find((i) => i.attribute === key)?.refinements || [];
            const refinedElements = values.filter((v) => v.isRefined === true);
            if (!refinedElements?.length) continue;
            for (let index = 0; index < refinedElements.length; index++) {
              const element = refinedElements[index];
              if (!newActivateFacetElements.find((e) => (e.value === element.value))) {
                const value = element.value;
                const name = key;
                document.dispatchEvent(new CustomEvent('facet-value-changed', {
                  bubbles: true,
                  composed: true,
                  detail: { name, value }
                }));
              }
            }
          }
        }
      }


      widgetParams.container.innerHTML = `
          <ul>
            ${items.length ? '<span class="current-refinement-list-title"> Selected Filters </span>' : ''}
            ${items.map(renderListItem).join('')}
          </ul>
        `;

      [...widgetParams.container.querySelectorAll('button')].forEach(element => {
        element.addEventListener('click', event => {
          const item = Object.keys(event.currentTarget.dataset).reduce(
            (acc, key) => ({
              ...acc,
              [key]: event.currentTarget.dataset[key],
            }),
            {}
          );

          refine(item);
        });
      });
    };


    const customCurrentRefinements = connectCurrentRefinements(
      renderCurrentRefinements
    );

    return customCurrentRefinements;
  }

  
  _renderMainTemplate(_defaultTemplate, data, html) {
    const pageTitle = this.getAttribute('page-title-text') || '';
    const placeholder = this.getAttribute('searchbox-placeholder') || 'Search';
    const searchBoxSubtitle = this.getAttribute('searchbox-subtitle');
    const clearSingleFilterText = this.CLEAR_SINGLE_FILTER_TEXT;
    const viewResultsText = this.VIEW_RESULTS_TEXT;
    
    const toggleRefinementsNames = this.toggleRefinementsNames;

    if (algoliaShopify.translations) {
      algoliaShopify.translations.searchForProduct = placeholder
    }

    return html`
      <div class="ais-page" data-view-mode="${this.viewMode}" data-viewport="${this.isMobile ? 'mobile' : 'desktop'}" id="algolia-main-content">
        <div class='ais-header-container' style="display:none">
          <div class="custom-algolia-inner">
            <h1 class="custom-algolia-page-title">${pageTitle}</h1>
            ${searchBoxSubtitle ? html`
              <div class="ais-header-subtitle">
                  ${html([searchBoxSubtitle])}
              </div>
            ` : ''}
            <div class="ais-input">
              <div class="ais-search-box-container"></div>
              <div class="ais-input-button">
                <div class="ais-clear-input-icon"></div>
              </div>
            </div>        
          </div>
        </div>
        <div class="custom-algolia-content custom-algolia-inner">
          <div class="ais-facets-button" style="display:none;">
            ${algoliaShopify.translations?.showFilters}
          </div>
          <div class="ais-facets" id="custom-ais-facets">
              <div id="custom-clear-refinements"></div>
              <div id="current-refinements"></div>
              ${data?.facets?.filter((f) => {
      if ( f.type !== "hidden") {
        return true
      }
      return false
    }).map(
      facet =>
        html` 
                          <div class="custom-facet">
                              <custom-facet-modal 
                                facet-name="${facet.name}" 
                                facet-title="${facet.title}"
                                clear-filter-text="${clearSingleFilterText}"
                                view-results-text="${viewResultsText}"
                              >
                              </custom-facet-modal>
                          </div>
                      `
    )}
        ${data?.facets?.filter((f) => toggleRefinementsNames.has(f.name)).map(facet => 
          html   `<div id="toggle-refinement-event-${facet.name}" class="toggle-refinement-event"></div>`
        )}
          </div>
          <div class="ais-facets" style="display:none;">
            <div class="ais-clear-refinements-container"></div>
            <div class="ais-current-refined-values-container"></div>
            ${data?.facets.map(
      facet =>
        html`
                      <div
                        class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                      >
                        <label
                          for="${facet.escapedName}"
                          class="ais-range-slider--header ais-facet--header ais-header"
                          >${facet.title}</label
                        >
                        <input
                          class="ais-dropdown-checkbox"
                          type="checkbox"
                          id="${facet.escapedName}"
                          name="dropdown"
                        />
                        <div
                          class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                        ></div>
                      </div>
                    `
    )}
          </div>
          <div class="ais-block">
            <div class="ais-search-header">
              <div class="ais-stats-container"></div>
              <div class="ais-change-display">
                <span class="ais-change-display-block ais-change-display-selected"
                  ><i class="fa fa-th-large"></i
                ></span>
                <span class="ais-change-display-list"
                  ><i class="fa fa-th-list"></i
                ></span>
              </div>
              <div class="ais-sort">
                ${data?.multipleSortOrders
        ? html`
                              ${algoliaShopify.translations?.sortBy}
                              <span class="ais-sort-orders-container"></span>
                            `
        : html`
                      ${algoliaShopify.translations?.sortBy}
                      ${algoliaShopify.translations?.relevance}
                    `}
              </div>
            </div>
            <div class="ais-block stats-header">
              <div id="custom-current-venue-stats"></div>
              <div role="button" id="guide-view-mode" style="cursor: pointer;" onclick="${this.changeView}">
                 ${html([this.renderViewButton()])}
              </div>
            </div>
            <div class="ais-block map-view">
              <div class="ais-hits-container ais-results-as-block"></div>
              <div id="geo-search"></div>
            </div>
          </div>
          <div class="ais-pagination-container"></div>
        </div>
      </div>
    `;
  }

  renderViewButton(render = true) {
    if (!this.htmlHelper) return;

    //const mapHTML = '<span class="gvm-helper-text">Map</spa
    const mapHTML = '<span class="gvm-helper-text">Map</span> <svg class="svg_map" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080"><path fill="#fefefe" fill-rule="evenodd" d="M788 165q-22 6-39 23a79 79 0 0 0-22 61q2 33 25 55c35 32 89 30 119-6 25-30 26-72 2-104a86 86 0 0 0-44-29c-12-3-30-3-41 0"/><path fill="#1c161c" fill-rule="evenodd" d="m479 259-25 4c-37 3-161 25-166 29l-4 7a6955 6955 0 0 1-107 257l-70 171-36 94 1 4c2 1 20 0 42-3a437 437 0 0 1 105 2c28 4 52 8 62 12l26 13 30 18a1964 1964 0 0 1 160 110c10 7 12 8 55 6a1400 1400 0 0 1 225 6 1266 1266 0 0 1 118 12l6 2q8 4 10-12l3-19a2429 2429 0 0 0 25-158l14-96 26-181 13-86 12-78 5-36v-3l-6 1-12 1-7 2-4 5-3 6h4l7-1 3-1v7l-15 94-20 137q2 4-7-3-6-5-15-9-10-5-7-6l6-40 12-65 15-80q1-5-5 5c-6 9-6 10-10 37l-25 138q1 5-6 3c-13-6-59-14-61-12l-35 60-6-9-39-57 3 6h-3c-9 2-9 2-53-15q-59-23-59-27l27-88q1-3-5-10l-5-7-1 3-29 95q-3 0-14-10-8-8-23-31c-18-27-23-33-29-39-8-6-23-12-32-12l-15 2q-37 6-51-7c-4-4-13-17-19-30l-7-12 11-30 16-38c5 0 30 9 52 19l116 52-3-5q-3-4-9-7l-153-65q-3 0 1-9l3-8 14 5 67 27 55 22-3-6-3-6-15-6-112-48c-6-3-15-4-16-3m-15 15-27 2a1292 1292 0 0 0-139 23q-2 1-6 11l-3 9 20-5a936 936 0 0 1 166-28l3-8 2-6h-3zm-9 21-29 4a1324 1324 0 0 0-142 27l-17 43-21 50 15-7c24-13 46-20 81-25q26-4 35-9l14-9c17-10 23-12 37-12h16l5 1 11-31 12-33q1-2-17 1m-36 69q-11 1-25 12a98 98 0 0 1-48 17c-39 6-69 16-98 33l-8 5-4 11c-6 14-6 15-5 15l32-10c2 0 0 6-2 8l-17 5-17 6c-2 1-9 16-8 17l9-2q27-9 27-7l-1 4c-2 4-2 4-19 8q-16 4-19 6c-2 2-54 123-53 124l6-4a370 370 0 0 1 196-70l16-1 3-6 23-68-12-3q-11-2-9-3l1-3q-1-2 7-2l12 3 5 2 3-9 2-9-16-4q-7 1-4-3l1-3q1-2 15 1l8 1 23-62 3-8h-2c-4-2-20-2-25-1m23 44-12 33 7 4 6 5-3 6-6-3-7-4-3 9-3 8 6 4q7 4 4 7l-2 3-6-3q-4-3-5-2l-25 67 10 3a228 228 0 0 1 83 41v-2c0-2 3-6 17-18l9-7c3 0 4 3 6 19 3 19 3 21-1 22q-3 1-1 4l1 9v5l12 9c39 28 67 45 69 42l11-36 1-5-6-6-12-11-5-5 2-3 2-3 10 9 11 10 5-12c3-11 3-11 1-13l-17-13 1-5 2-2 7 5c12 9 12 9 14 0l20-67-6-5q-12-7-29-34c-27-40-31-44-43-50-10-4-19-4-37-1-13 2-31 1-42-4q-14-6-29-38l-4-5zm-83 24h-11l-1 4-1 4 19-1h18l2-4 1-3-8-1zm-31 2-43 7q-10 2-10 6v4l15-3 26-5c18-2 19-2 19-4l1-6zm18 23q-6-1-8 5-1 4 3 3l17-2h15l2-3 1-3zm105 2-2 4 46 31 2-3q3-4 0-5l-44-30zm-134 1-24 5c-25 4-26 4-27 8q-2 5 1 4l60-12 1-4q1-2-4-2zm122 25c-1 3-1 3 22 18l23 16q3-4 2-7c-5-5-43-30-45-30zm67 14q-2 2 1 4l44 35 3-7-41-32q-7-6-7 0m152 20-11 39-12 38 8 6 7 6-3 6-7-5-7-5-1 5-4 10c-3 11-3 12 3 17q6 5 5 7-2 9-8 0-5-4-6-3l-9 31h41l-5-6q-7-7-4-12c2-1 2-1 9 5l19 21 11 13-2 4-2 4-11-13q-11-13-12-12l-46 3-18 59-20 66-3 9 21-6a942 942 0 0 1 128-23q2 0-3-11l-3-12 6-7c2 0 15 45 15 50l-3 1-4 2-4-8-2-8a398 398 0 0 0-67 9 707 707 0 0 0-84 20q-3 1-4 7l-34 107 47-1c46-1 88-1 148 2 53 3 103 4 114 4h12l4-17 28-157v-3h-11q-52 3-88 11l-5 1v6l1 5-4 2-5 1-1-10c-1-9-3-15-12-38l-5-12 3-3 4-2 13 30 5 15 13-2a541 541 0 0 1 93-11l18-100v-3l-5 1a374 374 0 0 1-154 4l-20 11 8 10 21 29 2 4-4 2-3 2-6-8a297 297 0 0 0-30-40l2-4q2-3 4-1c2 2 3 2 12-3q11-6 6-6c-6-1-25-8-32-11q-24-11-31-26c-3-8 0-20 7-28 11-12 39-24 65-29l7-2-18-6zm-163 3v4l45 36q2 0 2-3l2-3-23-18-23-19zm67 20q-3 4 5 10l24 20 3-7-30-25zm-211 6c-19 2-48 7-64 12a332 332 0 0 0-126 65 942 942 0 0 0-63 156l9-1a316 316 0 0 1 60-7 741 741 0 0 1 56-57c32-30 46-40 63-45q17-4 38-3l11 1 44-120c0-2-1-2-13-2zm39 2-23 62-22 60 5 1q23 11 36 26 13 14 20 47c9 38 21 60 41 75q15 13 46 9c14-1 25-4 43-8 20-6 17-3 24-25l24-79 12-41-6-4c-12-6-32-20-69-46l-14-10v5q0 7-3 6l-7-2-6-2-6 17-8 16-3-2-2-1 7-16 6-17-8-3q-12-5-10-8-1-2 5-5 7-3 3-5-4-5 3-8l3-1-4-4c-15-14-51-32-73-37q-14-3-14 0m161 19q-2 3 1 5l25 23 3-3 1-3-9-8-19-17zm-49 7-6 7 2 1q5 4 2 8l-6 2q-5 1-5 4 1 5-6 9l-6 4 10 3 12 5v-6q0-7 2-6h5l3 2-2-8q-4-12 2-11l4 1-2-10-2-10zm-88 10q-13 12-12 13 2 4-4 5-10 4-5 8v3l-5 4q-4 2-2 5l2 2 7 3 7 3-6 13c-7 18-7 17-3 18l3 1 5-13 6-15h6q10 5 9-4-1-5 3-3 7 0 5-10-3-6 0-6 6 0 2-12l-2-15q0-11-4-10zm3 6-5 5 2 2q6 5-6 9-5 1-3 3t-2 5l-5 4-2 2 18 8v-3q-1-9 3-9l4 1q3 4 0-6c-2-7-2-7 0-9l3-1q3 0 2-3l-3-13zm242 26-1 4 14 11 22 17c9 7 10 7 12 3 1-3 0-4-11-13l-34-25q-2 0-2 3m287 15a123 123 0 0 1-33 16 828 828 0 0 0-18 97l-5 27-31 172c-1 0-86-2-134-5a1882 1882 0 0 0-176 0l-19 1-5 12-4 15-1 3h6l17-1a1599 1599 0 0 1 261 10l91 8c2-1 3-8 9-42l6-42 26-182 14-92zm-636 40c-24 1-39 7-60 25-11 9-72 70-74 74-1 1 0 2 18 2 30 0 45 2 77 11l20 4a1447 1447 0 0 0 40-115c-2-1-15-2-21-1m33 8c-6 12-29 75-37 100l-5 14 4 2a492 492 0 0 1 119 68l30 21c27 18 61 44 62 47a783 783 0 0 0 35-109l-10 2c-27 8-43 11-62 11-14 0-21-2-31-8q-19-13-32-38l-14-39c-7-30-12-42-23-53-8-9-22-18-33-21q-2-2-3 3m174 1-13 11c-10 10-11 11-11 14q2 3-4 4-13 6-7 10 5 2-2 5l-5 4q-3 2 0 4l9 5 8 3-6 17-7 16 3 1 3 1 7-17 6-16 5 3q12 6 11-5-2-7 1-4h8v-11q-3-6 0-5l3-3-4-35q-1-5-5-2m-8 16-7 6 3 2 3 3q1 4-8 7-7 0-4 5 1 3-5 7l-6 4 11 4 10 4v-6q1-10 7-6l3 2-3-8c-2-8-2-8-1-10l5-1h2l-3-19zm182 11-2 4 4 6 15 26 3-3 3-2-4-8c-4-9-14-24-16-26q-1-1-3 3m-545 71a265 265 0 0 0-52 7l-12 30 16-2a417 417 0 0 1 141 1l38 7 3-4 9-23-47-12-19-4-30-1zm633 19-4 2 1 22 1 22q3 1 8-2v-44q-1-3-6 0m-480 3-9 24 10 7a1328 1328 0 0 1 176 113l29 21c1 0 4-7 11-29q1-2-2-2t-17-11a949 949 0 0 0-77-56 457 457 0 0 0-73-45zm431 16-3 1 1 14 1 19q-1 6 4 5c5 0 6-2 5-18-2-24-1-23-8-21m50 39q-4 1-4 5l-6 44q-1 3 3 2c7 0 7 0 10-16 2-12 3-33 2-34q1-2-5-1m-47 13q-4 1-4 5l-4 39h5l4-1 2-7c1-9 3-37 1-37z"/><path fill="#b40434" fill-rule="evenodd" d="M788 52q-51 7-90 31a196 196 0 0 0-80 106q-15 50-6 95a221 221 0 0 0 41 85l32 47 124 183 9 14 13-21 53-89 73-119c41-65 55-108 50-154A199 199 0 0 0 847 54c-10-2-16-2-31-3zm0 113q-22 6-39 23a79 79 0 0 0-22 61q2 33 25 55c35 32 89 30 119-6 25-30 26-72 2-104a86 86 0 0 0-44-29c-12-3-30-3-41 0"/></svg>';


    const listHTML = '<span class="gvm-helper-text">List</span><svg class="svg_list" xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 16 16"><path fill="#000000" d="M2 4V3h2v1zm4 0V3h8v1zm0 3V6h8v1zm0 3V9h8v1zM2 7V6h2v1zm0 3V9h2v1zm4 3v-1h8v1zm-4 0v-1h2v1z"/></svg>'


    const htmlContent =
      this.viewMode === "map"
        ? listHTML
        : mapHTML;


    if (render) {
      return htmlContent;
    } else {
      const viewModeButton = document.getElementById("guide-view-mode");
      if (viewModeButton) {
        viewModeButton.classList.add("fade-out");
        setTimeout(() => {
          viewModeButton.innerHTML = htmlContent;
          viewModeButton.classList.remove("fade-out");
        }, 300);
      }
    }
  }

  changeView() {
    const newViewMode = this.viewMode === "list" ? "map" : "list"
    const url = new URL(window.location.href);
    url.searchParams.set("viewMode", newViewMode);
    this.setViewMode(newViewMode);
    const nextUrl = `${url.pathname}${url.search}${url.hash || ""}`;
    window.history.replaceState(window.history.state, "", nextUrl);
  }



  disableMobileMapMode() {
    const auto = this.getAutocompleteWidget();
    if (!auto) return;
    this.enableListMode(auto);
  }

  setViewportMode() {
    const mainBlock = document.getElementById("algolia-main-content");
    if (mainBlock) {
      mainBlock.setAttribute("data-viewport", this.isMobile ? "mobile" : "desktop")
    }
  }

  setEmptyMode(mode) {
    const mainBlock = document.getElementById("algolia-main-content");
    if (mainBlock) {
      mainBlock.setAttribute("data-empty", mode)
    }
  }

  setViewMode(mode) {
    const mainBlock = document.getElementById("algolia-main-content");
    if (mainBlock) {
      mainBlock.setAttribute("data-view-mode", mode)
      this.setViewportMode();
      this.viewMode = mode;
      this.renderViewButton(false)

      if (mode === "map") {
        this.scheduleAllMapPinsRender();
      } else {
        this.clearAllMapPins();
      }

      const auto = this.getAutocompleteWidget();
      if (!auto) return;

      if (this.isMobile) {
        if (mode === "map") {
          this.enableMapMode(auto);
        } else {
          this.enableListMode(auto);
        }
      }
    }
  }
  enableMapMode(auto) {
    //  Scroll to top before locking
    window.scrollTo({ top: 0, behavior: "smooth" });

    // Lock body scroll
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    // Hide site header
    const headerComponents = document.querySelector(".header-sections");
    if (headerComponents) {
      headerComponents.style.display = "none"
    }


    // Hide siblings
    const parent = auto.parentElement;
    Array.from(parent.children).forEach(child => {
      if (child !== auto) child.style.display = "none";
    });

    const btnScrollToTop = document.querySelector('[data-scroll-top-button]');
    if (btnScrollToTop) {
      btnScrollToTop.style.opacity = '0'
    }

    const shopifySection = auto.closest("[id^='shopify-section']");
    if (shopifySection) {
      shopifySection.style.background = "white";
    }

    // Remove RTE paddings (PT/PB)
    const rteSection = auto.closest("main")?.querySelector("section[id^='Rte--template']");
    if (rteSection) {
      rteSection.style.paddingTop = "2rem";
      rteSection.style.paddingBottom = "0";
    }
  }

  enableListMode(auto) {
    //  Enable scroll
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";

    // Show header again
    // Hide site header
    const headerComponents = document.querySelector(".header-sections");
    if (headerComponents) {
      headerComponents.style.display = ""
    }


    //  Show siblings again
    const parent = auto.parentElement;
    Array.from(parent.children).forEach(child => {
      child.style.display = "";
    });
    const btnScrollToTop = document.querySelector('[data-scroll-top-button]');
    if (btnScrollToTop) {
      btnScrollToTop.style.opacity = '1'
    }

    //  Reset Shopify section sticky
    const shopifySection = auto.closest("[id^='shopify-section']");
    if (shopifySection) {
      shopifySection.style.zIndex = "";
    }

    // Restore RTE padding
    const rteSection = auto.closest("main")?.querySelector("section[id^='Rte--template']");
    if (rteSection) {
      rteSection.style.paddingTop = "";
      rteSection.style.paddingBottom = "";
    }
  }

  _renderHitTemplate(_defaultTemplate, hit, html, components, trackSearchAttribution) {
    const hitImage = algoliaShopify.helpers.renderImage(hit, 1000);

    const relevantKeys = new Set([
      "index",
      "productPosition",
      "queryID",
      "objectID",
      "handle",
      "objectID",
      "_distinct",
      "title",
      "meta",
      "tags"
    ])

    //  Filter hit properties
    const hitObj = Object.fromEntries(
      Object.entries(hit).filter(([key]) => relevantKeys.has(key))
    );


    // Convert functions to strings
    const trackSearchAttributionStr = trackSearchAttribution ? trackSearchAttribution.toString() : '';
    const componentsStrings = {}
    Object.keys(components).forEach((k) => {
      componentsStrings[k] = components[k]?.toString()
    })

    return html`<algolia-product-hit
            hit='${JSON.stringify(hitObj)}'
            hit-image='${JSON.stringify(hitImage)}'
            components='${JSON.stringify(componentsStrings)}'
            track-search-attribution='${trackSearchAttributionStr || ''}'
            btg-images='${this.BTG_IMAGES}'
            btg-rating-logo='${this.BTG_LOGO}'
        ></algolia-product-hit>`;
  }

  _renderNoResultsTemplate(_defaultTemplate, html) {
    const noResultsText = this.getAttribute('widget-no-results') || 'No Results found';
    return html`
    <div class="ais-hit-empty">
      <div class="ais-hit-empty--title">
           ${html([noResultsText])}
      </div>
      <div class="ais-hit-empty--clears">
        ${algoliaShopify.translations.try} ${' '}
        <a class="ais-hit-empty--clear-filters ais-link">
          ${algoliaShopify.translations.clearFilters} ${' '}
        </a>
        ${algoliaShopify.translations.or} ${' '}
        <a class="ais-hit-empty--clear-input ais-link">
          ${algoliaShopify.translations.changeInput}
        </a>
      </div>
    </div>
  `;
  }


  _renderSearchStatsTemplate(_defaultTemplate, data, html) {
    // Set document title
    if (this.WIDGET_HTML_DOCUMENT_TITLE) {
      document.title = this.WIDGET_HTML_DOCUMENT_TITLE;
    }

    // Save the total number of hits 
    if (this.initialRender["all"] !== true) {
      this.totalHits = data.nbHits ?? 0;
      this._updateTotalHitsCount();
      this.initialRender["all"] = true;
    }

    const paginationElement = document.querySelector(".ais-Pagination-list");
    paginationElement?.classList.toggle("hide", data?.hasNoResults === true);

    this._updateStatsElements(data);
  }

  _updateStatsElements(data) {
    const hasQuery = this.currentQuery && this.currentQuery.trim() !== "";


    // Set global property
    this.setEmptyMode(data.nbHits === 0 ? "true" : "false");

    // Update stats element
    const currentStatsElement = document.getElementById("custom-current-venue-stats");
    if (currentStatsElement) {
      const statsText = this._replacePlaceholders(
        hasQuery ? this.WIDGET_STATS_TEXT : this.WIDGET_STATS_TEXT_NO_QUERY,
        data,
        hasQuery
      );
      currentStatsElement.textContent = statsText;
      currentStatsElement.classList.toggle("inactive", data.nbHits === 0);
    }

    // Update view results buttons (mobile)
    const viewResultsButtons = document.querySelectorAll(".custom-facet-modal-actions-view");
    if (viewResultsButtons.length) {
      viewResultsButtons.forEach((e) => {
        const placeholderText = e.getAttribute("data-placeholder-text");
        if (placeholderText) {
          const updatedText = this._replacePlaceholders(
            hasQuery ? this.WIDGET_VIEW_RESULTS_TEXT : this.WIDGET_VIEW_RESULTS_TEXT_NO_QUERY,
            data,
            hasQuery
          );
          e.textContent = updatedText;
        }
      });
    }
  }

  _updateTotalHitsCount() {
    const clearRefinementButton = document.getElementById("custom-clear-refinements");
    if (clearRefinementButton) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            const spanElement = clearRefinementButton.querySelector(".clear-refinements-text");
            if (spanElement) {
              const textContent = spanElement.textContent;
              spanElement.textContent = `${textContent} (${this.totalHits})`;
              observer.disconnect();
            }
          }
        });
      });
      observer.observe(clearRefinementButton, { childList: true, subtree: true });
    }
  }

  _capitalizeWords(string) {
    return string.split(' ').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ')
  }


  _replacePlaceholders(text, data, hasQuery = false) {
    if (!text) return '';
    // If there's no query we use the no query version
    if (!hasQuery) {
      return text
        .replace('${VENUES_NUMBER}', data.nbHits || 0);
    }
    const transformedText = this._capitalizeWords(this.currentQuery)
    return text
      .replace('${VENUES_NUMBER}', data.nbHits || 0)
      .replace('${WIDGET_QUERY}', transformedText || "");
  }


  resetRefinement(facetName) {
    if (!this.facets[facetName]) return;
    this.facets[facetName].filter((f) => f.isRefined === true).forEach((f, idx) => {
      const facetId = `${facetName}--${f.value}`;
      const facetElement = document.querySelector(`[data-custom-facet-id="${facetId}"]`)
      if (facetElement) {
        facetElement.click()
      }
    })
    // Close modal
    const viewResultsElement = document.querySelector(`[data-id="view-results-label-${facetName}"]`);
    if (viewResultsElement) {
      viewResultsElement.click()
    }
  }

  _getBtgRatingTexts() {
    try {
      const scriptElement = document.getElementById('btg-rating-texts-data');
      if (scriptElement) {
        return JSON.parse(scriptElement.textContent);
      }
    } catch (e) {
      console.warn('Failed to parse btg-rating-texts from script tag:', e);
    }

    // Fallback to default values
    return {
      "1": { "title": "One glass", "subtitle": "Good choice" },
      "2": { "title": "Two glasses", "subtitle": "Excellent choice" },
      "3": { "title": "Three glasses", "subtitle": "Premium choice" },
      "4": { "title": "Four glasses", "subtitle": "Premium choice" }
    };
  }


}

customElements.define('algolia-search-widget', AlgoliaSearchWidget);
